module.exports = __webpack_public_path__ + "static/media/privacy.c1a06e30.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/privacy.pdf
// module id = 479
// module chunks = 2